// extracted by mini-css-extract-plugin
export default {"link":"tL-z","disabled":"uL-z"};